import { render, staticRenderFns } from "./SelectedFreightRatesPage.vue?vue&type=template&id=05309365&scoped=true"
import script from "./SelectedFreightRatesPage.vue?vue&type=script&lang=js"
export * from "./SelectedFreightRatesPage.vue?vue&type=script&lang=js"
import style0 from "./SelectedFreightRatesPage.vue?vue&type=style&index=0&id=05309365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05309365",
  null
  
)

export default component.exports